module.exports = __webpack_public_path__ + "img/confirmation.0e7712aa.svg";